import React, { useState } from "react";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Form,
    Statistic,
    Col,
    Divider,
    Spin,
    Table,
    Typography,
    Collapse,
    Select,
    DatePicker,
    Button,
    Modal,
    Tooltip,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import {
    PlusOutlined,
    DeleteOutlined,
    EditOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import dayjs from "dayjs";
import styles from "../../../../../../assets/styles/styles";
import { apiConfig, labelConfig } from "../../../../group.config";


const ChargesForm = (props) => {
    //DECLARED VARIABLES
    const {
        onFinish,
        form,
        formData,
        chargesOptions,
        userData,
        isLoading,
        setIsLoading,
        chargeTableSource,
        setChargeTableSource,
    } = props;
    const { session } = userData;
    // const [useForm] = Form.useForm();
    const { Title } = Typography;

    console.log(chargesOptions);


    // DECLARED VARIABLES FOR CHARRGES FORM
    const [chargeList, setChargeList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleChargeDelete = (key) => {
        let action = "Delete  ";
        let label = BOM.SubstringFormat(key.name, 20);

        Notiflix.Confirm.show(
            "Are you sure?",
            action + label,
            "Yes",
            "No",

            function () {
                const newData = chargeTableSource.filter((item) => item.id !== key.id);
                setChargeTableSource(newData);
            },

            function () {
                // No button
            }
        );
    };

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Type",
            dataIndex: "type",
        },
        {
            title: "Amount",
            dataIndex: "amount",
        },
        {
            title: "Collected On",
            dataIndex: "collectedOn",
        },
        {
            title: "Date",
            dataIndex: "dueDate",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) =>
                chargeTableSource.length >= 1 ? (
                    <>
                        <Tooltip title={`Remove Charge`}>
                            <Button
                                type="primary"
                                icon={<DeleteOutlined />}
                                onClick={() => handleChargeDelete(record)}
                                shape="round"
                                size="small"
                                className="of-primaryBtnColor"
                            />
                        </Tooltip>
                        &nbsp;
                        < EditCharge
                            selectedRecord={record}
                            chargeTableSource={chargeTableSource}
                            setChargeTableSource={setChargeTableSource}
                        />
                    </>) : null,
        },
    ];

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.chargeInfo}
                </Title>
            </Divider>
            <ChargeModal
                formData={formData}
                isModalOpen={isModalOpen}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                setIsModalOpen={setIsModalOpen}
                chargeData={chargesOptions}
                setChargeList={setChargeList}
                setChargeTableSource={setChargeTableSource}
                chargeTableSource={chargeTableSource}
                chargeList={chargeList}
                session={session}
            />

            {chargeTableSource?.length > 0 && (
                <>
                    <Divider orientation="left" orientationMargin="0">
                        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                            {chargeTableSource.length > 1
                                ? labelConfig.selectedCharges
                                : labelConfig.selectedCharge}
                        </Title>
                    </Divider>
                    <Table
                        columns={columns}
                        dataSource={chargeTableSource}
                        bordered
                        pagination={{
                            position: "bottomCentre",
                            pageSize: "10",
                        }}
                    />
                </>
            )}
        </Form>
    );
};
export default ChargesForm;

const ChargeModal = (props) => {
    const {
        session,
        isLoading,
        setIsLoading,
        setChargeTableSource,
        chargeTableSource,
        isModalOpen,
        chargeData,
        setIsModalOpen,
    } = props;
    const dateFormat = 'YYYY/MM/DD';

    const [useForm] = Form.useForm();
    const [noDateNoRepayments, setNoDateNoRepayments] = useState(true);
    const [isDateShown, setIsDateShown] = useState(true);

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleChargeSave = (formValues) => {
        const newCharges = {
            key: formValues?.chargeId,
            id: formValues?.chargeId,
            name: formValues.name,
            type: formValues.type,
            collectedOn: formValues.collectedOn,
            amountToUse: formValues?.amount,
            amount: (
                <Statistic
                    value={formValues?.amount}
                    precision={2}
                    valueStyle={{ fontSize: "16px" }}
                />
            ),
            dueDate: formValues.dueDate
                ? BOM.DateTime(formValues.dueDate, "only-date")
                : "-",
        };

        let foundCharge = chargeTableSource.find(
            (item) => item.id === newCharges?.id
        );
        if (foundCharge) {
            BOM.AlertMsg(cnt.WARNING, labelConfig.noDuplicateCharges);
            return;
        }
        setChargeTableSource([...chargeTableSource, newCharges]);
        useForm.resetFields();
    };

    const handleSelectedCharge = (chargeId) => {
        const params = {
            template: "true",
        };

        const url = `${apiConfig.Charges}/${chargeId}`;

        const body = {
            session,
            params,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            } else {
                const objList = res;

                switch (objList?.chargeTimeType?.value.toLowerCase()) {
                    case "saving no activity fee":
                    case "savings activation":
                    case "withdrawal fee":
                    case "fx transaction fee":
                    case "overdraft fee":
                        setNoDateNoRepayments(false)
                        break;
                    case "monthly fee":
                    case "weekly fee":
                        setNoDateNoRepayments(true);
                        break;
                    case "specified due date":
                    case "annual fee":
                        setNoDateNoRepayments(true);
                        setIsDateShown(true);
                        break;

                    default:
                        break;
                }

                useForm.setFieldsValue({
                    key: objList.id,
                    id: objList.id,
                    name: objList.name,
                    type: objList.chargeCalculationType.value,
                    collectedOn: objList?.chargeTimeType.value,
                    amount: objList?.amount,
                    dueDate: objList?.feeOnMonthDay
                        ? dayjs(BOM.FormatArrayDate(objList?.feeOnMonthDay))
                        : objList?.feeOnMonthDay,
                });

                // STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <Row>
            <Button
                type="primary"
                onClick={showModal}
                icon={<PlusOutlined />}
                style={{
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    backgroundColor: "#15CCAE",
                    marginBottom: 20,
                }}
            >
                {labelConfig.add}
            </Button>

            <Modal
                title={labelConfig.ChargeInformationSetup}
                open={isModalOpen}
                okText="Add"
                cancelText="Cancel"
                okButtonProps={{
                    autoFocus: true,
                    htmlType: "submit",
                    style: {
                        ...styles.ofPrimaryBtnColor,
                    },
                }}
                centered
                onCancel={handleCancel}
                width={800}
                modalRender={(dom) => (
                    <Form
                        form={useForm}
                        layout="vertical"
                        onFinish={handleChargeSave}
                        name="address-info"
                    >
                        {dom}
                    </Form>
                )}
                style={{
                    height: 600,
                    overflow: "auto",
                }}
            >
                <Spin spinning={isLoading} tip="Loading..." size="large">
                    <Row>
                        <Divider />

                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                name="chargeId"
                                label="Charge Options"
                                rules={[
                                    {
                                        required: true,
                                        message: BOM.CheckReqFld(labelConfig.charge),
                                    },
                                ]}
                            >
                                <Select
                                    filterOption={(input, option) =>
                                        (option?.label?.toLowerCase() ?? "").includes(
                                            input?.toLowerCase()
                                        )
                                    }
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.charge,
                                        "select"
                                    )}
                                    options={chargeData}
                                    onChange={handleSelectedCharge}
                                    style={{ width: "30vh" }}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Divider />
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.name}
                                name="name"
                            >
                                <Input
                                    disabled
                                    className="of-bold-disable-input"
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.type}
                                name="type">
                                <Input
                                    disabled
                                    className="of-bold-disable-input"
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.collectedOn}
                                name="collectedOn">
                                <Input
                                    disabled
                                    className="of-bold-disable-input"
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.collectedOn
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.amount}
                                name="amount">
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                                />
                            </Form.Item>
                        </Col>
                        {noDateNoRepayments &&
                            <>
                                {isDateShown &&
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={labelConfig.date}
                                            name="dueDate">
                                            <DatePicker
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    labelConfig.date,
                                                    "select"
                                                )}
                                                style={{ width: "100%", height: 35 }}
                                                format={dateFormat}
                                            />
                                        </Form.Item>
                                    </Col>
                                }
                            </>
                        }
                    </Row>
                </Spin>
            </Modal>
        </Row>
    );
};
const EditCharge = (props) => {
    const dateFormat = 'YYYY/MM/DD';

    const {
        selectedRecord,
        setChargeTableSource,
        chargeTableSource,
    } = props;

    const [useForm] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        console.log(selectedRecord);
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onSubmit = (values) => {
        console.log(values.amount);

        values.key = selectedRecord?.key;
        values.dueDate = values.dueDate ? BOM.DateTime(values.dueDate, "only-date") : " - ";
        values.amount === undefined && delete values.amount;

        const editedChargeRecord = chargeTableSource.map(item =>
            item.key === values.key ? { ...item, ...values } : item
        );
        setChargeTableSource(editedChargeRecord);
        setIsModalOpen(false);
    };

    return (
        <>
            <Tooltip title="Edit Charge">
                <Button
                    type="primary"
                    icon={<EditOutlined />}
                    onClick={showModal}
                    shape="round"
                    size="small"
                    className="of-primaryBtnColor"
                />
            </Tooltip>
            <Modal
                title="Edit Charge"
                open={isModalOpen}
                okText="Submit"
                cancelText="Cancel"
                okButtonProps={{
                    autoFocus: true,
                    htmlType: "submit",
                    style: {
                        ...styles.ofPrimaryBtnColor,
                    },
                }}
                centered
                onCancel={handleCancel}
                width={800}
                modalRender={(dom) => (
                    <Form layout="vertical" form={useForm} onFinish={onSubmit}>
                        {dom}
                    </Form>
                )}
                style={{
                    height: 600,
                    overflow: "auto",
                }}
            >
                <Row>
                    <Col span={12} style={{ padding: "0px 8px" }}>
                        <Form.Item
                            label={labelConfig.dueOn}
                            name="dueDate"
                        >
                            <DatePicker
                                placeholder={BOM.handlePlaceholderMsg(
                                    labelConfig.dueDate,
                                    "select"
                                )}
                                style={{ width: "100%", height: 32.5 }}
                                format={dateFormat}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12} style={{ padding: "0px 8px" }}>
                        <Form.Item
                            label={labelConfig.amount}
                            name="amount"
                        >
                            <Input
                                placeholder={BOM.handlePlaceholderMsg(
                                    labelConfig.amount,
                                    "select"
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>

            </Modal>
        </>
    );
};
